(() => {
  const config = document.querySelector('[data-kathare-bundle-stock-config]');
  if (!config || document.documentElement.hasAttribute('data-kathare-bundle-stock-ready')) return;
  const { productIds, variantIds } = JSON.parse(config.textContent);
  const products = new Set(productIds);
  const variants = new Set(variantIds);
  const originals = new WeakMap();
  document.documentElement.setAttribute('data-kathare-bundle-stock-ready', '');

  function isBundle(form) {
    if (!form || !/\/cart\/add(?:\.js)?$/.test(new URL(form.action, location.href).pathname)) return false;
    return products.has(form.dataset.productId) || variants.has(form.querySelector('[name="id"]')?.value);
  }

  function appButton(form) {
    const buttons = form.querySelectorAll('.gbbPbAddToCartBtn');
    return buttons.length === 1 ? buttons[0] : null;
  }

  function available(button) {
    return !!button && !button.disabled && button.getAttribute('aria-disabled') !== 'true'
      && !button.closest('[hidden]') && button.getClientRects().length > 0;
  }

  function sync(form) {
    const app = appButton(form);
    const ready = available(app);
    for (const button of form.querySelectorAll('button[name="add"], button[id^="ProductSubmitButton-"]')) {
      if (button.matches('.gbbPbAddToCartBtn')) continue;
      const label = button.querySelector(':scope > span');
      if (!originals.has(button)) originals.set(button, label?.textContent || '');
      if (button.disabled !== !ready) button.disabled = !ready;
      const aria = String(!ready);
      if (button.getAttribute('aria-disabled') !== aria) button.setAttribute('aria-disabled', aria);
      if (!app && button.getAttribute('aria-busy') !== 'true') button.setAttribute('aria-busy', 'true');
      if (app && button.hasAttribute('aria-busy')) button.removeAttribute('aria-busy');
      const text = !ready && app ? app.querySelector('.gbbPbAddToCartLabel')?.textContent : originals.get(button);
      if (label && text && label.textContent !== text) label.textContent = text;
    }
  }

  function refresh() {
    for (const form of document.querySelectorAll('form[action]')) if (isBundle(form)) sync(form);
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.('button[name="add"], button[id^="ProductSubmitButton-"]');
    if (!button || button.matches('.gbbPbAddToCartBtn')) return;
    const form = button.form;
    if (!isBundle(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    sync(form);
    const app = appButton(form);
    if (available(app)) app.click();
  }, true);

  document.addEventListener('submit', event => {
    if (!isBundle(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    sync(event.target);
  }, true);

  new MutationObserver(refresh).observe(document.documentElement, {
    subtree: true, childList: true, characterData: true,
    attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'hidden', 'value', 'class', 'style']
  });
  document.addEventListener('change', refresh);
  refresh();
})();
